import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CONTACT } from "@/data/content";

export const CTABand = ({ title = "Ready when you are.", text }) => (
  <section data-testid="cta-band" className="relative overflow-hidden bg-ink text-white">
    <div className="grid-bg absolute inset-0 opacity-40" aria-hidden />
    <div className="absolute -right-32 -top-32 h-96 w-96 rounded-full bg-brand/30 blur-3xl" aria-hidden />
    <div className="relative mx-auto flex max-w-7xl flex-col gap-10 px-4 py-20 sm:px-6 md:flex-row md:items-center md:justify-between">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-widest text-brand-light">{CONTACT.name}</p>
        <h2 className="mt-4 max-w-xl font-display text-3xl font-bold leading-tight tracking-tight sm:text-4xl">{title}</h2>
        {text && <p className="mt-4 max-w-lg text-base leading-relaxed text-slate-300">{text}</p>}
      </Reveal>
      <Reveal delay={0.1}>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link to="/contact" data-testid="cta-quote-button" className="btn-primary">
            Request a Quote <ArrowRight size={16} />
          </Link>
          <Link to="/services" data-testid="cta-services-button" className="btn-on-dark">View Services</Link>
          <a href={CONTACT.phoneHref} data-testid="cta-call-button" className="btn-on-dark">Call {CONTACT.phone}</a>
        </div>
      </Reveal>
    </div>
  </section>
);
